import React, { useState, useEffect } from "react";

import moment from "moment";

import { FetchResult } from "../../../services/doFetch";
import { GameSummaries } from "../../../types/GameTypes";
import useAsyncError from "../../../services/useAsyncError";
import { fetchRecentGames } from "../../../services/GameService";
import Spinner from "../../UI/Spinner";

import "./RecentGames.scss";
import { Link } from "react-router-dom";

const pageSize = 15;

function LeaderboardRecentGames() {
  const [result, setResult] = useState<FetchResult<GameSummaries>>({ loading: false });

  const throwError = useAsyncError();

  const { loading, data } = result;

  useEffect(() => {
    (async () => {
      try {
        await fetchRecentGames(pageSize, setResult);
      } catch (e) {
        throwError(e);
      }
    })();
  }, [throwError]);

  const summaries = data;

  return (
    <div className="leaderboard-recent-games">
      {loading && (
        <div className="spinner">
          <Spinner />
        </div>
      )}

      {summaries && (
        <div className="recent-games leaderboard-pane">
          <table>
            <tbody>
              {summaries.map((summary) => (
                <tr key={summary.nonce}>
                  <td>
                    <span className="player">{summary.player}</span>
                  </td>
                  <td>{moment(summary.ended).calendar(null, { sameElse: "MMM Do YYYY" })}</td>
                  <td>
                    <Link to={`/game/${summary.nonce}`}>{summary.score}</Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default LeaderboardRecentGames;
